module.exports = __webpack_public_path__ + "img/组 14 拷贝@2x.82bb56a1.png";